import React, { useState, useEffect, useRef } from 'react'
import { Card, Popover } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import {
  formatMessageNew,
  downLoadFileBlob,
  formatStartTime,
  formatEndTime,
  initValueAndLabel,
  uniqueFun,
  isChineseFun,
  dateFormatYearMonthDay,
  numFormat
} from '@/utils/common'
import {
  getCscSummaryReport,
  getCscSummaryDropDown,
  exportSummaryReportDownload
} from '@/services/rfid/csc/outboundSummary'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
import { CSC_REPORT_TYPE } from '@/utils/types'
const startMonth = dayjs().subtract(6, 'day')
const endMonth = dayjs().subtract(0, 'day')
const defaultReportType = '1'
let selectOptions = {}
const OutboundSummaryReport = () => {
  const [tableList, setTableList] = useState([])
  const [reportType, setReportType] = useState(defaultReportType)
  const [queryFlag, setQueryFlag] = useState(false)
  const mounting = useRef(false)
  let formRef = useRef(null)
  let searchListInit = [
    {
      type: 'select',
      label: 'languageObj.outboundSummary.reportType',
      key: 'reportType',
      // allowClear: true,
      initialValues: defaultReportType,
      selectList: CSC_REPORT_TYPE,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true',
      handleChange: (e, idx, item) => {
        setReportType(e)
        searchListInit.forEach(itemFirst => {
          if (itemFirst.key === 'orderTypeList') {
            let arr = []
            if (itemFirst.key === 'orderTypeList') {
              if (e === '1') {
                arr = selectOptions['3'] || []
              }
              if (e === '2') {
                arr = selectOptions['4'] || []
              }
            }
            itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 2))
          }
        })
        setSearchList([...searchListInit])
        formRef && formRef.current.setValue({ orderTypeList: [] })
        setQueryFlag(preQueryFlag => !preQueryFlag)
      }
    },
    {
      type: 'select',
      label: 'languageObj.outboundSummary.cscName',
      key: 'cscNameList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRange',
      label: 'languageObj.outboundSummary.giDate',
      key: 'rangeDate',
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > dayjs().endOf('day')
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true',
      allowClear: false
    },
    {
      type: 'select',
      label: 'languageObj.outboundSummary.orderType',
      key: 'orderTypeList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.outboundSummary.shipFrom',
      key: 'shipFromList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.outboundSummary.shipTo',
      key: 'shipToList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.outboundSummary.cscName'),
      dataIndex: 'cscName',
      fixed: 'left',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title:
        reportType === defaultReportType
          ? formatMessageNew('languageObj.outboundSummary.byCarton')
          : formatMessageNew('languageObj.outboundSummary.byExp'),
      dataIndex: 'reportType',
      children: [
        {
          title:
            reportType === defaultReportType
              ? formatMessageNew('languageObj.outboundSummary.cordCarton')
              : formatMessageNew('languageObj.outboundSummary.cordCartonExp'),
          dataIndex: 'cordCartonQty',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.noScanQty'),
          dataIndex: 'noScanQty',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.rfidScannedQty'),
          dataIndex: 'rfidScannedQty',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.accurateQty'),
          dataIndex: 'accurateQty',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.epcShortageQty'),
          dataIndex: 'epcShortageQty',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.epcOverageQty'),
          dataIndex: 'epcOverageQty',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.upcMismatchQty'),
          dataIndex: 'upcMismatchQty',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.unexpectedQty'),
          dataIndex: 'unexpectedQty',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.byCartonAccuracy'),
          dataIndex: 'byCartonAccuracy',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        }
      ]
    },
    {
      title: formatMessageNew('languageObj.outboundSummary.byPiece'),
      dataIndex: 'byPiece',
      children: [
        {
          title: formatMessageNew('languageObj.outboundSummary.cordEpcQty'),
          dataIndex: 'cordEpcQty',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.noScanQtyPiece'),
          dataIndex: 'noScanQtyPiece',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.rfidScannedQtyPiece'),
          dataIndex: 'rfidScannedQtyPiece',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.accurateQtyPiece'),
          dataIndex: 'accurateQtyPiece',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.epcShortageGapQtyPiece'),
          dataIndex: 'epcShortageGapQtyPiece',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.epcOverageGapQtyPiece'),
          dataIndex: 'epcOverageGapQtyPiece',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.upcMismatchQtyPiece'),
          dataIndex: 'upcMismatchQtyPiece',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.unexpectedQtyPiece'),
          dataIndex: 'unexpectedQtyPiece',
          width: 150,
          render: text => {
            return <div className="word_break_all">{numFormat(text)}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.outboundSummary.byEpcAccuracy'),
          dataIndex: 'byEpcAccuracy',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        }
      ]
    }
  ]
  useEffect(() => {
    mounting.current && searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    getSelectOptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSelectOptions = () => {
    getCscSummaryDropDown().then(res => {
      res.resultData.forEach(item => {
        selectOptions[item.type] = item.value
      })
      searchListInit.forEach(itemFirst => {
        if (
          itemFirst.key === 'shipFromList' ||
          itemFirst.key === 'shipToList' ||
          itemFirst.key === 'cscNameList' ||
          itemFirst.key === 'orderTypeList'
        ) {
          let arr = []
          if (itemFirst.key === 'shipFromList') {
            arr = selectOptions['1'] || []
          }
          if (itemFirst.key === 'shipToList') {
            arr = selectOptions['2'] || []
          }
          if (itemFirst.key === 'cscNameList') {
            let ls = selectOptions['5'] || []
            arr = ls.map(mapItem => {
              let l = mapItem.split(',')
              return {
                value: l[0],
                label: l[1]
              }
            })
          }
          if (itemFirst.key === 'orderTypeList') {
            arr = selectOptions['3'] || []
          }
          if (itemFirst.key === 'cscNameList') {
            itemFirst.selectList = uniqueFun(arr, 1, 'label')
          } else {
            itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 2))
          }
        }
      })
      setSearchList([...searchListInit])
    })
  }
  const downLoadFun = () => {
    const params = {
      ...getParams(),
      ...isChineseFun()
    }
    exportSummaryReportDownload(params).then(res => {
      downLoadFileBlob(res)
    })
  }
  const searchDataBtn = () => {
    mounting.current = true
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    mounting.current = true
    formRef && formRef.current.clearForm()
    setQueryFlag(!queryFlag)
  }
  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const { rangeDate } = info
    const params = {
      ...info,
      startGiDate: formatStartTime(rangeDate),
      endGiDate: formatEndTime(rangeDate)
    }
    delete params.rangeDate
    return params
  }
  const searchDataFun = () => {
    const params = {
      ...getParams()
    }
    getCscSummaryReport(params).then(res => {
      const dt = res.resultData
      setTableList(dt)
    })
  }
  const getPopoverContent = () => {
    let ls1 = [1, 2, 3, 4, 5, 6, 7, 8, 9]
    let ls2 = [1, 2, 3, 4, 5, 6, 7, 8, 9]
    return (
      <div>
        <div
          className="tagTypeVal"
          dangerouslySetInnerHTML={{ __html: formatMessageNew('languageObj.outboundSummary.tipTitle1') }}
        ></div>
        {ls1.map((item, idx) => {
          return (
            <div
              key={idx}
              dangerouslySetInnerHTML={{ __html: formatMessageNew(`languageObj.outboundSummary.tip${item}`) }}
            ></div>
          )
        })}

        <div className="tagTypeVal mt10">{formatMessageNew('languageObj.outboundSummary.tipTitle2')}</div>
        {ls2.map((item, idx) => {
          return (
            <div
              key={idx}
              dangerouslySetInnerHTML={{ __html: formatMessageNew(`languageObj.outboundSummary.tipPiece${item}`) }}
            ></div>
          )
        })}
      </div>
    )
  }
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            // showCollapseBtn={true}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container pt10">
          <Popover
            trigger="click"
            color="#f5f5f5"
            className="mr10 cursorPointer"
            overlayStyle={{ maxWidth: '75vw', maxHeight: '95vh', overflow: 'auto' }}
            placement="right"
            content={getPopoverContent()}
          >
            <InfoCircleOutlined className="mb8" style={{ fontSize: 16 }} />
          </Popover>
          <AntdTable
            // rowKey={record => record.id}
            // 独一无二的表示，不能重复
            columnsKey={'columns_outboundSummaryReport_' + reportType}
            onDownload={downLoadFun}
            dataSource={tableList}
            columns={tableColumns}
            pagination={false}
          />
        </div>
      </Card>
    </div>
  )
}
export default OutboundSummaryReport
